import { SupplementDto } from "../dtos";
import dinero, { Dinero } from "dinero.js";
import { prepPrice } from "../../utils";

export class Supplement {
  id: number;
  name: string;
  avatar: string;
  description?: string;
  uomId = -1;
  uomName = "";
  price: Dinero = dinero();
  vat: Dinero = dinero();
  serving_activities: number[] = [];

  constructor(dto: SupplementDto) {
    this.id = dto.id;
    this.name = dto.name;
    this.avatar = dto.avatar;
    this.description = dto.description;
    this.uomId = dto.uom.id;
    this.uomName = dto.uom.name;
    this.price = dinero({ amount: prepPrice(dto.price) });
    this.vat = dinero({ amount: prepPrice(dto.vat) });
    this.serving_activities = dto.serving_activities;
  }
}
